import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AlignCenterOutlinedSvg from "@ant-design/icons-svg/es/asn/AlignCenterOutlined";
import AntdIcon from "../components/AntdIcon";
var AlignCenterOutlined = function AlignCenterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AlignCenterOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  AlignCenterOutlined.displayName = 'AlignCenterOutlined';
}
export default /*#__PURE__*/React.forwardRef(AlignCenterOutlined);